<template>
	<div class="fullWidthImageContainer" :class="alignmentClass">
		<img 
			:src="image.sizes['ct-extra-large']"
		/>
	</div>
</template>

<script>

export default {
	name: 'FullWidthImage',
	props: ["image", "alignment"],
	components: {

	},
	computed: {
		alignmentClass() {
			switch (this.alignment) {
				case 'Bottom':
					return 'alignBottom'
				case 'Top':
					return 'alignTop'
				default:
					return 'alignMid'
			}
		}
	}
}
</script>

<style lang="scss" scoped>
	.fullWidthImageContainer {
		height: auto;
		max-height: 700px;
		overflow: hidden;
		position: relative;
		display: flex;
		flex-direction: column;
		&.alignBottom { 
			justify-content: flex-end;
		}
		&.alignTop {
			justify-content: flex-start;
		}
		&.alignMid {
			justify-content: center;
		}

		img {
			width: 100%;
		}
	}
</style>